import { ImportHistory } from '@ardoq/api-types/integrations';
import { fetchEntities } from '../api';
import { Persisted } from '@ardoq/api-types';

export const historyApi = {
  fetchAll: fetchEntities<Persisted<ImportHistory>>('integrations/history'),
};
